(() => {
  if (window.oddProductReveal || !('IntersectionObserver' in window)) return;
  window.oddProductReveal = true;
  const selector = '.product-card,.product-card-small';
  const scope = document.querySelector('main') || document.body;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new Set();
  function finish(card, delay = 0, immediate = false) {
    pending.delete(card); observer.unobserve(card);
    if (immediate || reduced.matches) { card.dataset.oddReveal = 'done'; return; }
    card.style.setProperty('--odd-reveal-delay', delay + 'ms');
    card.dataset.oddReveal = 'revealing';
    let timeout;
    const cleanup = event => {
      if (event && (event.target !== card || event.propertyName !== 'transform')) return;
      clearTimeout(timeout); card.removeEventListener('transitionend', cleanup);
      card.dataset.oddReveal = 'done'; card.style.removeProperty('--odd-reveal-delay');
    };
    card.addEventListener('transitionend', cleanup);
    timeout = setTimeout(cleanup, 1000 + delay);
  }
  const observer = new IntersectionObserver(entries => {
    const visible = entries.filter(e => e.isIntersecting).sort((a,b) => a.boundingClientRect.top-b.boundingClientRect.top || a.boundingClientRect.left-b.boundingClientRect.left);
    let rowTop = -Infinity, index = 0;
    for (const entry of visible) {
      if (Math.abs(entry.boundingClientRect.top-rowTop) > 36) { rowTop = entry.boundingClientRect.top; index = 0; }
      finish(entry.target, Math.min(index++ * 55, 220));
    }
  }, {threshold: .01, rootMargin: '0px 0px 35px 0px'});
  function scan(roots) {
    const cards = new Set();
    for (const root of roots) {
      if (!root.isConnected) continue;
      if (root.matches?.(selector)) cards.add(root);
      root.querySelectorAll(selector).forEach(card => cards.add(card));
    }
    // Complete layout reads before applying styles.
    const states = [...cards].filter(card => !card.dataset.oddReveal && !card.closest('dialog,cart-drawer,header,.predictive-search')).map(card => {
      const rect = card.getBoundingClientRect();
      return {card, visible:reduced.matches || (rect.width && rect.top < innerHeight && rect.bottom > 0)};
    });
    for (const {card,visible} of states) {
      card.dataset.oddReveal = visible ? 'done' : 'pending';
      if (!visible) { pending.add(card); observer.observe(card); }
    }
  }
  scan([scope]);
  const queued = new Set(); let frame = 0;
  new MutationObserver(records => {
    let removed = false;
    for (const record of records) {
      if (record.removedNodes.length) removed = true;
      record.addedNodes.forEach(node => { if (node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))) queued.add(node); });
    }
    if (removed) for (const card of pending) if (!card.isConnected) { observer.unobserve(card); pending.delete(card); }
    if (!frame && queued.size) frame = requestAnimationFrame(() => {
      frame = 0; const roots=[...queued]; queued.clear();
      scan(roots.filter(node => !roots.some(other => other !== node && other.contains(node))));
    });
  }).observe(scope, {childList:true,subtree:true});
  document.addEventListener('focusin', event => {
    const card = event.target.closest?.(selector);
    if (card?.dataset.oddReveal === 'pending') finish(card, 0, true);
  });
  reduced.addEventListener('change', () => { if (reduced.matches) [...pending].forEach(card => finish(card, 0, true)); });
  document.addEventListener('shopify:section:load', event => scan([event.target]));
})();
